import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../Icon';
import { Documents, Play } from '../../../../assets/images';

import {
  WrapperResultItem,
  WrapperImage,
  WrapperHeader,
  WrapperIconContent,
  WrapperBody,
  ResultTitle,
  StyledDateFormat,
  ResultParagraph,
  StyledCircle,
  StyledIcon
} from './style';

/** Components */
import Thumbnail from '../../views/SearchModal/Thumbnail';

const NewsItem = ({
  className,
  imgSrc,
  title,
  date,
  text,
  urlLink,
  onClick,
  mediaType
}) => (
  <WrapperResultItem className={className} to={urlLink} onClick={onClick}>
    {imgSrc && (
      <WrapperImage mediaType={mediaType}>
        <Thumbnail path={imgSrc} alt={title} />
        {mediaType === 'VIDEO' && (
          <StyledCircle>
            <StyledIcon svg={Play} size="m" hover />
          </StyledCircle>
        )}
      </WrapperImage>
    )}
    <WrapperBody>
      <WrapperHeader>
        <WrapperIconContent>
          <Icon svg={Documents} size="m" hover />
        </WrapperIconContent>
        <div>
          <ResultTitle>{title}</ResultTitle>
          <StyledDateFormat format="DD/MM/YY">{date}</StyledDateFormat>
        </div>
      </WrapperHeader>
      {text && (
        <div>
          <ResultParagraph maxlength={140} text={text} />
        </div>
      )}
    </WrapperBody>
  </WrapperResultItem>
);

NewsItem.propTypes = {
  className: PropTypes.string,
  urlLink: PropTypes.string,
  imgSrc: PropTypes.string,
  title: PropTypes.string,
  date: PropTypes.string,
  text: PropTypes.string,
  onClick: PropTypes.func
};

NewsItem.defaultProps = {
  urlLink: '/'
};

export default NewsItem;
